import { Filter } from '../filter';
import { ErrorType, FieldValues } from '../types';

export class MaxLengthFilter implements Filter<string> {
    constructor(private maxLengthIncluded: number) {}

    async validate(fieldValue: string, otherFields: FieldValues): Promise<Array<ErrorType>> {
        if (fieldValue.length > this.maxLengthIncluded) {
            return [{ code: 'max', maximum: this.maxLengthIncluded }];
        }
        return [];
    }
}
